import React, { useState } from 'react'

interface SafeImageProps extends React.ImgHTMLAttributes<HTMLImageElement> {
    src: string
    alt: string
    fallbackSrc?: string
    className?: string
    imageStyle?: React.CSSProperties
}

const SafeImage: React.FC<SafeImageProps> = ({
    src,
    alt,
    fallbackSrc,
    className = '',
    imageStyle = {},
    ...props
}) => {
    const [error, setError] = useState(false)
    const [isLoading, setIsLoading] = useState(true)

    const isValidSrc =
        src.startsWith('/') ||
        src.startsWith('http://') ||
        src.startsWith('https://') ||
        src.startsWith('data:image')

    if ((error || !isValidSrc) && fallbackSrc) {
        return (
            <img
                src={fallbackSrc}
                alt={alt}
                className={className}
                style={{ width: '100%', height: '100%', ...imageStyle }}
                {...props}
            />
        )
    }

    if (error || !isValidSrc) {
        return (
            <div
                className={`relative flex items-center justify-center bg-gray-200 dark:bg-gray-700 ${className}`}
                style={{ width: '100%', height: '100%', ...imageStyle }}
            >
                {/* {src} */}
                <svg
                    className="w-1/2 h-1/2 text-gray-400 dark:text-gray-500"
                    fill="none"
                    stroke="currentColor"
                    viewBox="0 0 24 24"
                >
                    <path
                        strokeLinecap="round"
                        strokeLinejoin="round"
                        strokeWidth={2}
                        d="M4 16l4.586-4.586a2 2 0 012.828 0L16 16m-2-2l1.586-1.586a2 2 0 012.828 0L20 14m-6-6h.01M6 20h12a2 2 0 002-2V6a2 2 0 00-2-2H6a2 2 0 00-2 2v12a2 2 0 002 2z"
                    />
                </svg>
            </div>
        )
    }

    return (
        <div
            className="relative"
            style={{ width: '100%', height: '100%', ...imageStyle }}
        >
            {isLoading && (
                <div
                    className={`absolute inset-0 bg-gray-200 dark:bg-gray-700 animate-pulse rounded-lg ${className}`}
                />
            )}

            <img
                src={src}
                alt={alt}
                className={`${className} ${isLoading ? 'opacity-0' : 'opacity-100 w-full h-full'
                    }`}
                style={imageStyle}
                {...props}
                onError={() => setError(true)}
                onLoad={() => setIsLoading(false)}
            />
        </div>
    )
}

export default SafeImage
